import {GET_ATTACHMENTS} from "../../../enums/Request/request.types";

export const getAttachmentsAction = (array) => {
    return {
        type: GET_ATTACHMENTS,
        payload: array,
    };
};
